import { OrgAndIntroducerAndAdvisorFilter } from '../generated/resolvers'
import request from '../requesters/search'

export const orgAndIntroducerAndAdvisorFiltersDiscovery = async () => {
  const response = await request.get<OrgAndIntroducerAndAdvisorFilter>(`/discovery/filters`)

  return response.data || null
}
